import { Container, Button } from '@material-ui/core';
import React from 'react'
import MaterialContext from '../contexts/material';
import LocalStorage from '../local_storage/LocalStorage'
import debug from '../utils/debugging'
export default function Dev(props) {
	const { setPrimaryTheme } = React.useContext(MaterialContext)
	const [isRebel, setIsRebel] = React.useState(false)
	return <Container component="main" maxWidth="md">
		<br />
		<br />
		<Button onClick={LocalStorage.clear} variant="contained">Clear</Button>
		<br />
		<br />
		<Button onClick={() => debug.log(LocalStorage.getAll())} variant="contained">
			Show Local Storage in Console
		</Button>

		<br />
		<br />
		<br />
		<Button
			variant="contained"
			onClick={() => {
				setIsRebel(!isRebel)
				setPrimaryTheme(isRebel ? '#1b50a6' : '#BF2E1A')
			}}>
			Switch theme
		</Button>
	</Container>

}